
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.019 26.194"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"data-name":"Pfad 65","d":"M1.601 26.194a1.621 1.621 0 01-1.6-1.637V1.637A1.621 1.621 0 011.601 0h11.73a1.621 1.621 0 011.6 1.637v3.82a.533.533 0 11-1.066 0v-3.82a.54.54 0 00-.533-.546H1.601a.54.54 0 00-.533.546v22.92a.54.54 0 00.533.543h11.73a.54.54 0 00.533-.546v-3.82a.533.533 0 111.066 0v3.82a1.621 1.621 0 01-1.6 1.637z"}}),_c('path',{attrs:{"data-name":"Pfad 66","d":"M19.921 18.989a.554.554 0 01-.393-.946l4.6-4.6H4.396a.554.554 0 110-1.109h19.73l-4.6-4.6a.555.555 0 010-.784.544.544 0 01.391-.164.556.556 0 01.393.162l5.544 5.544a.554.554 0 01.121.6.535.535 0 01-.121.18l-5.543 5.544a.555.555 0 01-.39.173z"}})])])
          )
        }
      }
    